const o = Math.floor(Math.random() * 45360 + 1296);
let t = 0;
const I = () => (t += 1, `${o.toString(36)}${t.toString(36)}`);
export {
  I as identifier
};
//# sourceMappingURL=identifier.js.map
